import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/facebook.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/instagram.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/twitter.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/pinterest.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/youtube.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/popsell.svg';
export default {
  name: 'Socials',
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};